import { SortSelector } from "@components/common/sort-selector";
import { SortItem, SortOption } from "@custom-types/sort-types";

interface Props<TSortBy extends string, TSortField extends string> {
  /** Current sort by value */
  sortBy: TSortBy;

  /** Callback to update sort by value */
  setSortBy: (sortBy: TSortBy) => void;

  /** Available options shown in sort selector */
  sortOptions: Record<TSortField, SortOption<TSortField>>;

  /** Map to convert sortBy values to SortItem values */
  sortByMap: Record<TSortBy, SortItem<TSortField>>;

  /** Fallback sort when incoming value is invalid */
  defaultSortBy: TSortBy;

  /** Convert SortItem back to sortBy value */
  getSortBy: (sortItem: SortItem<TSortField>) => TSortBy;

  /** Subject label used for tracking */
  subjectType: string;
}

/**
 * Generic sort base component used by members and team members sort selectors.
 */
export function MembersSortBase<TSortBy extends string, TSortField extends string>({
  sortBy,
  setSortBy,
  sortOptions,
  sortByMap,
  defaultSortBy,
  getSortBy,
  subjectType,
}: Props<TSortBy, TSortField>): JSX.Element {
  const validSortBy = sortByMap[sortBy] ? sortBy : defaultSortBy;

  function handleSortChange(newSortItem: SortItem<TSortField>): void {
    setSortBy(getSortBy(newSortItem));
  }

  return (
    <SortSelector
      sortOptions={sortOptions}
      sortItem={sortByMap[validSortBy]}
      setSortItem={handleSortChange}
      subjectType={subjectType}
    />
  );
}
